import {API_PATCH_QUESTIONANSWER, API_UPDATE_PI_QUESTIONANSWER} from "actions/questionAnswer";


export function patchQuestionAnswer(data) {
    return {
        type: API_PATCH_QUESTIONANSWER,
        payload: {
            request: {
                url: `/questionAnswer/answers`,
                method: "PATCH",
                data: data
            },
            data: data
        }
    };
}

export function editPIQuestionAnswer(folderId, pi){
    return {
        type: API_UPDATE_PI_QUESTIONANSWER,
        payload: {
            request: {
                url: `/questionAnswer/answers/pi`,
                method: "PUT",
                data: {folder: folderId, pi: pi}
            },
        }
    };
}
